export class Selfie {
	public Image: string;
	public Latitude: number; // Maintain both naming styles if required by other parts of the app
	public latitude: number;
	public longitude: number;
	public city: string;
	public country: string;

	public Longitude: number;
	public BrowserName: string;
	public BrowserVersion: string;
	public isVirtual: number;
	AttemptCount: number;
	ApiHitCount: any;
	City: any; // Remove these if they are duplicates or unnecessary
	Country: any;
	State: any;
}
